import { take, takeEvery, fork, all, call } from 'redux-saga/effects';
import { apiTask } from '../app/sagas';
import { api } from '../app/api';

import * as actions from './addProfileActions';

export const getSchools = apiTask(
  actions.GET_SCHOOLS,
  api.post,
  '/evaluation-system/getSchools.php',
);
export function* watchGetSchools() {
  while (true) {
    const { payload } = yield take(actions.GET_SCHOOLS);
    yield fork(getSchools, payload);
  }
}

export const getProfile = apiTask(
  actions.GET_PROFILE,
  api.post,
  '/evaluation-system/getProfile.php',
);
export function* watchGetProfile() {
  while (true) {
    const { payload } = yield take(actions.GET_PROFILE);
    yield fork(getProfile, payload);
  }
}

export const getProfilesTypes = apiTask(
  actions.GET_PROFILES_TYPES,
  api.post,
  '/evaluation-system/getProfileTypes.php',
);
export function* watchGetProfilesTypes() {
  while (true) {
    const { payload } = yield take(actions.GET_PROFILES_TYPES);
    yield fork(getProfilesTypes, payload);
  }
}

export const getEvaluations = apiTask(
  actions.GET_EVALUATIONS,
  api.post,
  '/evaluation-system/getEvaluations.php',
);
export function* watchGetProfileEvaluations() {
  while (true) {
    const { payload } = yield take(actions.GET_EVALUATIONS);
    yield fork(getEvaluations, payload);
  }
}

export const addTeacher = apiTask(
  actions.ADD_TEACHER,
  api.post,
  '/evaluation-system/addTeacher.php',
);
export function* watchAddTeacher() {
  while (true) {
    const { payload } = yield take(actions.ADD_TEACHER);
    yield fork(addTeacher, payload);
  }
}

export const editTeacher = apiTask(
  actions.EDIT_TEACHER,
  api.post,
  '/evaluation-system/editTeacher.php',
);
export function* watchEditTeacher() {
  while (true) {
    const { payload } = yield take(actions.EDIT_TEACHER);
    yield fork(editTeacher, payload);
  }
}

export const getFilteredCatalogings = apiTask(
  actions.GET_FILTERED_CATALOGINS,
  api.post,
  '/evaluation-system/getFilteredCatalogings.php',
);
export function* watchGetFilteredCatalogings() {
  while (true) {
    const { payload } = yield take(actions.GET_FILTERED_CATALOGINS);
    yield fork(getFilteredCatalogings, payload);
  }
}

export function* sagas() {
  yield all([
    fork(watchGetSchools),
    fork(watchGetProfile),
    fork(watchGetProfilesTypes),
    fork(watchGetProfileEvaluations),
    fork(watchAddTeacher),
    fork(watchEditTeacher),
    fork(watchGetFilteredCatalogings),
  ]);
}
